import { Box, Tooltip } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import { memo } from "react";
import { HeatSummary } from "src/store/api/generatedApi";
import { useTenantTranslation } from "hooks/formatters";
import { TimelineSlot } from "./timelineLayout";

dayjs.extend(utc);

interface HeatMarkersProps {
  heats: HeatSummary[];
  slot: TimelineSlot;
  getPositionPercent: (time: Dayjs) => number;
}

export const HeatMarkers = memo(
  ({ heats, slot, getPositionPercent }: HeatMarkersProps) => {
    const { t } = useTenantTranslation();

    return (
      <>
        {heats.map((heat) => {
          const heatStart = dayjs.utc(heat.start);
          const heatEnd = dayjs.utc(heat.end);

          const leftPercent = getPositionPercent(heatStart);
          const widthPercent = getPositionPercent(heatEnd) - leftPercent;

          return (
            <Tooltip
              key={heat.heat_id}
              title={`${t("heat")} ${heat.heat_id}: ${heatStart.format(
                "YYYY-MM-DD HH:mm"
              )} – ${heatEnd.format("YYYY-MM-DD HH:mm")} UTC`}
              arrow
            >
              <Box
                sx={{
                  position: "absolute",
                  left: `${leftPercent}%`,
                  width: `${Math.max(widthPercent, 0.5)}%`,
                  top: slot.top,
                  height: slot.height,
                  bgcolor: "primary.main",
                  opacity: 0.7,
                  borderRadius: slot.borderRadius,
                  "&:hover": {
                    opacity: 0.9,
                  },
                }}
              />
            </Tooltip>
          );
        })}
      </>
    );
  }
);
HeatMarkers.displayName = "HeatMarkers";
